import AmexLogo from 'assets/images/png/card-brands/amex.png';
import DinersClubLogo from 'assets/images/png/card-brands/diners-club.png';
import DiscoverLogo from 'assets/images/png/card-brands/discover.png';
import JcbLogo from 'assets/images/png/card-brands/jcb.png';
import UnionpayLogo from 'assets/images/png/card-brands/unionpay.png';
import VisaLogo from 'assets/images/png/card-brands/visa.png';
import MastercardLogo from 'assets/images/png/card-brands/mastercard.png';

export const CARD_TO_CARD_LOGO_RELATIONS: { [key: string]: any } = {
  amex: AmexLogo,
  diners: DinersClubLogo,
  discover: DiscoverLogo,
  jcb: JcbLogo,
  unionpay: UnionpayLogo,
  visa: VisaLogo,
  mastercard: MastercardLogo,
};
